import { Link, useNavigate } from "react-router-dom";
import { CONTACT, IMG } from "../../data/assets";
import { useLanguage } from "../../lib/i18n";

export const Footer = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="relative bg-[--surface] border-t border-white/10 pt-14 pb-14">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="font-display text-2xl text-[--text] mb-3">Mediterranean <span className="italic text-[--gold]">Palate</span></p>
            <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-[--gold] mb-2">{t("footer.tagline")}</p>
            <p className="text-[--text-2] text-sm">Rutland • Stamford • East Midlands</p>
            <img src={IMG.logo} alt="Mediterranean Palate logo" data-testid="footer-logo" className="mt-6 w-24 md:w-28 rounded-xl border border-white/10" />
          </div>

          <div className="md:col-span-3 md:col-start-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[--gold] mb-5">{t("gallery.cta1k")}</p>
            <ul className="space-y-3 text-[--text-2] text-sm">
              <li><a href="/" className="nav-link hover:text-[--text] transition-colors">{t("nav.home")}</a></li>
              <li><a href="/#about" className="nav-link hover:text-[--text] transition-colors">{t("nav.about")}</a></li>
              <li><button data-testid="footer-menus" onClick={() => navigate("/menus")} className="nav-link hover:text-[--text] transition-colors">{t("nav.menus")}</button></li>
              <li><button data-testid="footer-gallery" onClick={() => navigate("/gallery")} className="nav-link hover:text-[--text] transition-colors">{t("nav.gallery")}</button></li>
              <li><Link to="/weddings" className="nav-link hover:text-[--text] transition-colors">{t("nav.weddings")}</Link></li>
              <li><Link to="/request-a-quote" className="nav-link hover:text-[--text] transition-colors">{t("nav.quote")}</Link></li>
              <li><Link to="/work-with-us" className="nav-link hover:text-[--text] transition-colors">{t("nav.work")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[--gold] mb-5">{t("footer.contact")}</p>
            <ul className="space-y-3 text-[--text-2] text-sm">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[--text] transition-colors break-all">{CONTACT.email}</a></li>
              <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-[--text] transition-colors">WhatsApp: {CONTACT.phoneDisplay}</a></li>
              <li><a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-[--text] transition-colors">@{CONTACT.instagram}</a></li>
              <li><button data-testid="footer-quote-btn" onClick={() => navigate("/request-a-quote")} className="hover:text-[--text] transition-colors">{t("nav.quote")}</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex justify-end items-center">
          <span className="text-[7px] italic text-[--text-2]">JF</span>
        </div>
      </div>
    </footer>
  );
};
